<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="砍价活动">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="goodslist-body show-goods-list" >
            <!-- 无限加载滚动列表 -->
            <div class="goods-list single-column" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div class="goods-item"
                     v-for='(item, index) in bargainList'
                     v-bind:key='index'
                >
                    <div class="goods-img">
                        <div class="img-content" style="height: 100px;">
                            <img :src="item.bargain_goods_image_url" />
                        </div>
                        <!---->
                    </div>
                    <div class="info-wrap">
                        <div class="name-wrap">
                            <div class="goods-name">
                                {{item.bargain_goods_name}}
                            </div>
                            <div class="progress-wrap">
                                <div class="progress-content">
                                    <div class="progress-bar">
                                        <div class="progress-inner-bar" :style="{'width':item.order_percent+'%'}"></div>
                                    </div>
                                    <!---->
                                </div>
                                <span class="color-base-text font-size-activity-tag txt lineheight-clear">
                                    <span>已砍{{item.order_count}}件</span>
                                </span>
                            </div>
                        </div>
                        <div class="lineheight-clear">
                            <div class="discount-price">
                                <span class="font-size-tag lineheight-clear txt">
                                    <span>底价：</span>
                                </span>
                                <span class="unit color-base-text font-size-tag">
                                    <span>&yen;</span>
                                </span>
                                <span class="price color-base-text font-size-toolbar">
                                    <span>{{item.bargain_floorprice}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="pro-info">
                            <div class="view-content delete-price font-size-activity-tag color-tip">
                                <span class="font-size-tag lineheight-clear txt">
                                    <span>原价：</span>
                                </span>
                                <span class="unit">
                                    <span>&yen;</span>
                                </span>
                                <span class="price">
                                    <span>{{item.bargain_goods_price}}</span>
                                </span>
                            </div>
                            <div class="view-content">
                                <div class="button-content" @click="goDetail(item)">
                                    去砍价
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading-wrapper" v-if="bargainList.length > 0">
                    <p class="common-no-more" v-if='!isMore'>没有更多了</p>
                    <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
                </div>
                <empty-record v-if='bargainList.length <= 0 && !isMore'></empty-record>
            </div>
        </div>

    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import { getBargainList } from '../../../api/homeBargain'
export default {
  name: 'PintuanList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      bargainList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  methods: {
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getBargainList(true)
      }
    },
    getBargainList () {
      Indicator.open()
      getBargainList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        if (this.bargainList) {
          this.bargainList = this.bargainList.concat(res.result.bargain_list)
        } else {
          this.bargainList = res.result.bargain_list
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    goDetail (item) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.bargain_goods_id, 'bargain_id': item.bargain_id } })
    }
  }
}
</script>

<style scoped lang='scss'>
    .goods-list.single-column .pro-info .button-content {width: 70px;line-height: 2.3;font-size:$fontSize;border-radius: 20px;text-align: center;color: #fff;background: $primaryGradualColor;}
    .font-size-activity-tag {font-size:$h6!important;}
    .font-size-tag {font-size:$fontSize!important;}
    .font-size-toolbar {font-size:$h2!important;}
    .color-tip { color: #909399!important; }
    .color-base-text {color: #ff4544!important;}
    .img-content >img{width: 100%;height: 100%;}
    .goods-list.single-column .goods-item {padding: 13px;background: #fff;margin: 10px 15px;border-radius: 5px;display: -webkit-box;display: -webkit-flex;display: flex;position: relative}
    .goods-list.single-column .goods-item .goods-img {width: 100px;height: 100px;overflow: hidden;border-radius: 5px;margin-right: 10px}
    .goods-list.single-column .goods-item .goods-img .img-content {width: 100%;height: 100%}
    .goods-list.single-column .goods-item .goods-tag {color: #fff;line-height: 1;padding: 4px 6px;position: absolute;border-top-left-radius: 5px;border-bottom-right-radius: 5px;top: 13px;left: 13px;font-size:$fontSize}
    .goods-list.single-column .goods-item .info-wrap {-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-webkit-flex-direction: column;flex-direction: column}
    .goods-list.single-column .goods-item .name-wrap {-webkit-box-flex: 1;-webkit-flex: 1;flex: 1}
    .goods-list.single-column .goods-item .goods-name {font-size:$subFontSize;line-height: 1.3;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 34px}
    .goods-list.single-column .goods-item .progress-wrap {display: -webkit-box;display: -webkit-flex;display: flex;margin-top: 5px;align-items: center;}
    .goods-list.single-column .goods-item .progress-wrap .progress-content {-webkit-box-flex: 1;-webkit-flex: 1;flex: 1}
    .goods-list.single-column .goods-item .progress-wrap .progress-content .progress-bar{background-color: rgb(255, 199, 199); height: 3px;}
    .goods-list.single-column .goods-item .progress-wrap .progress-content .progress-bar .progress-inner-bar{background-color: rgb(255, 69, 68);height:100%}
    .goods-list.single-column .goods-item .progress-wrap .txt {margin: 0 50px 0 10px}
    .goods-list.single-column .goods-item .discount-price {display: inline-block;font-weight: 700;line-height: 1;margin-top: 8px}
    .goods-list.single-column .goods-item .discount-price .unit {margin-right: 3px}
    .goods-list.single-column .goods-item .discount-price .txt {font-weight: 400}
    .goods-list.single-column .goods-item .pro-info {position: relative;margin-top: 8px}
    .goods-list.single-column .goods-item .pro-info .delete-price {-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-align: end;-webkit-align-items: flex-end;align-items: flex-end}
    .goods-list.single-column .goods-item .pro-info .delete-price .unit {margin-right: 3px;text-decoration: line-through}
    .goods-list.single-column .goods-item .pro-info .delete-price .price {text-decoration: line-through}
    .goods-list.single-column .goods-item .pro-info .view-content {line-height: 1}
    .goods-list.single-column .goods-item .pro-info .view-content:nth-child(2) {position: absolute;right: 0;bottom: 0}
    .goods-list.single-column .goods-item .member-price-tag {display: inline-block;width: 30px;line-height: 1;margin-left: 3px}
    .goods-list.single-column .goods-item .member-price-tag .img-content {width: 100%}
</style>
